export const indexLocations = [
  { city: 'Frankfurt', country: 'Germany', flag: 'de' },
  { city: 'Amsterdam', country: 'Netherlands', flag: 'nl' },
  { city: 'Copenhagen', country: 'Denmark', flag: 'dk' },
  { city: 'Helsinki', country: 'Finland', flag: 'fi' },
  { city: 'Stockholm', country: 'Sweden', flag: 'se' },
  { city: 'London', country: 'United Kingdom', flag: 'uk' },
  { city: 'Warsaw', country: 'Poland', flag: 'pl' },
  { city: 'Paris', country: 'France', flag: 'fr' },
  { city: 'Madrid', country: 'Spain', flag: 'es' },
  { city: 'Istanbul', country: 'Turkey', flag: 'tr' },
  { city: 'New York', country: 'USA', flag: 'us' },
  { city: 'Atlanta', country: 'USA', flag: 'us' },
  { city: 'Chicago', country: 'USA', flag: 'us' },
  { city: 'Miami', country: 'USA', flag: 'us' },
  { city: 'Dallas', country: 'USA', flag: 'us' },
  { city: 'Denver', country: 'USA', flag: 'us' },
  { city: 'Los Angeles', country: 'USA', flag: 'us' },
  { city: 'Toronto', country: 'Canada', flag: 'ca' },
  { city: 'Seattle', country: 'USA', flag: 'us' },
  { city: 'Mumbai', country: 'India', flag: 'in' },
  { city: 'Johannesburg', country: '', flag: 'sa' },
  { city: 'Sao Paolo', country: 'Brazil', flag: 'br' },
  { city: 'Santiago', country: 'Chile', flag: 'cl' },
  { city: 'Singapore', country: '', flag: 'sp' },
  { city: 'Hong Kong', country: '', flag: 'ch' },
  { city: 'Tokyo', country: '', flag: 'jp' },
  { city: 'Seoul', country: '', flag: 'sk' },
  { city: 'Sydney', country: '', flag: 'au' },
];
